module.exports = __webpack_public_path__ + "static/todo-list-a78f84a7fe8fef026eea5f58f3d516de.gif";